import React from 'react';
import { Link } from 'react-router-dom';
import { FaClock, FaPlay, FaPodcast } from 'react-icons/fa';
import './Blog.css';
import { useData } from './DataProvider';

const Blog = () => {
    const { blogData } = useData();

    // export const getPost = (id) => blogPosts.find(p => p.id === id); // Removed export as data is now async

    return (
        <div className="blog-container">
            <div className="blog-header">
                <FaPodcast className="blog-podcast-icon" />
                <div className="blog-header-content">
                    <div className="blog-label">Thoughts</div>
                    <h2 className="blog-title">Divy's Thoughts</h2>
                    <p className="blog-subtitle">Hot takes on society, AI, building, and everything in between.</p>
                </div>
            </div>

            <div className="posts-list-header">
                <div>#</div>
                <div>Title</div>
                <div>Date</div>
                <div><FaClock /></div>
            </div>

            <div className="blog-list">
                {blogData.map((post, idx) => (
                    <Link key={post.id} to={`/blog/${post.id}`} className="post-row">
                        <div className="post-index-col">
                            <span className="post-index">{idx + 1}</span>
                            <FaPlay className="post-play-icon" size={12} />
                        </div>

                        <div className="post-main-col">
                            <div className="post-title">{post.title}</div>
                            <div className="post-preview">{post.preview}</div>
                        </div>

                        <div style={{ fontSize: '14px' }}>{post.date}</div>

                        <div style={{ fontSize: '14px' }}>
                            {post.readTime}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Blog;
